import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FolderKanban, FileText, Image as ImageIcon, Inbox, Briefcase, Users } from "lucide-react";
import { adminApi, fmtDate } from "../api";
import { useAuth } from "../AuthContext";
import { RoleBadge } from "../components";

const Dashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get("/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const cards = [
    { label: "Projects", value: stats ? `${stats.projects_published} live / ${stats.projects_total} total` : "—", icon: FolderKanban, to: "/admin/projects" },
    { label: "Pages", value: stats?.pages ?? "—", icon: FileText, to: "/admin/pages" },
    { label: "Media Files", value: stats?.media ?? "—", icon: ImageIcon, to: "/admin/media" },
    { label: "Job Openings", value: stats?.jobs ?? "—", icon: Briefcase, to: "/admin/careers" },
    { label: "Enquiries", value: stats?.enquiries ?? "—", icon: Inbox, to: "/admin/enquiries" },
    { label: "Staff Users", value: stats?.users ?? "—", icon: Users, to: "/admin/users" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl font-bold text-slate-900">Welcome, {user.name}</h1>
          <p className="mt-1 text-sm text-slate-500 flex items-center gap-2">Signed in as <RoleBadge role={user.role} /></p>
        </div>
      </div>
      <div className="mt-7 grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} data-testid={`dash-card-${c.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="bg-white border border-slate-200 rounded-sm p-5 hover:border-[#C5221F] transition-colors duration-150">
            <c.icon size={20} className="text-[#C5221F]" />
            <p className="mt-3 font-display text-lg font-bold text-slate-900 leading-tight">{c.value}</p>
            <p className="text-[11px] uppercase tracking-widest text-slate-400 font-bold mt-1">{c.label}</p>
          </Link>
        ))}
      </div>
      <div className="mt-8 bg-white border border-slate-200 rounded-sm">
        <p className="px-6 py-4 border-b border-slate-200 font-display text-sm font-bold text-slate-900">Recent Activity</p>
        {stats?.recent_activity?.length ? (
          <ul className="divide-y divide-slate-100">
            {stats.recent_activity.map((a) => (
              <li key={a.id} className="px-6 py-3.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
                <span className="font-mono-tech text-[11px] text-slate-400 w-40 shrink-0">{fmtDate(a.at)}</span>
                <span className="font-semibold text-slate-800">{a.user_email}</span>
                <span className="text-slate-500">{a.action.replace(/_/g, " ")}</span>
                {a.detail && <span className="text-slate-400 text-xs truncate max-w-[240px]">{a.detail}</span>}
              </li>
            ))}
          </ul>
        ) : (
          <p className="px-6 py-8 text-sm text-slate-400">No activity recorded yet.</p>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
